import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.text
    ? _c(
        VApp,
        { attrs: { "data-mark-of-shame": "" } },
        [
          _vm.hasBackground
            ? _c(_setup.BaseAlert, {
                attrs: { color: "text-error", text: _setup.text },
              })
            : _c("div", { staticClass: "d-flex align-center" }, [
                _c("div", {
                  staticClass: "ui-icon-circle-info text-error--text mr-2",
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-2 text-error--text" }, [
                  _vm._v("\n      " + _vm._s(_setup.text) + "\n    "),
                ]),
              ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }